<template>
    <div :class="classList">
        <div class="dropzone-container">
            <vue-dropzone
                :id="id"
                ref="vueDropzone"
                :options="dropzoneOptions"
                :use-custom-slot="true"
                v-on="$listeners"
                @vdropzone-success="uploadSuccess"
                @vdropzone-removed-file="fileRemoved"
                @vdropzone-error="uploadError"
            >
                <div class="dropzone-custom-content">
                    <div class="dropzone-custom-title">
                        <div class="upload-icon">
                            <SrIcon icon="upload" size="l" :disabled="isDisabled" />
                        </div>
                        <span :class="uploadButtonClassNames">{{ uploadButtonTitle }}</span>
                    </div>
                    <div class="upload-subtext">...or drag and drop the file here</div>
                </div>
            </vue-dropzone>
        </div>
        <div v-if="!disableFileList" class="dropzone-filelist">
            <SrDropzoneUploadFileList
                v-if="!disableFileList"
                ref="fileList"
                v-model="fileList"
                class="file-list"
                @removeFile="removeFile"
            />
        </div>
    </div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone';
import prettyBytes from 'pretty-bytes';
import { USER_INPUT_CLASS } from '../../utils/classNames';
import { SrIcon } from '../SrIcon';
import { SrDropzoneUploadFileList } from '../SrDropzoneUploadFileList';

const ELEMENT_CLASS = 'sr-dropzone-upload';

export default {
    name: 'SrDropzoneUpload',
    components: {
        SrDropzoneUploadFileList,
        vueDropzone: vue2Dropzone,
        SrIcon,
    },
    props: {
        id: {
            type: String,
            required: true,
        },
        dropzoneOptions: {
            type: Object,
            required: true,
        },
        disableFileList: {
            type: Boolean,
            default: false,
        },
        dropzoneFileList: {
            type: Array,
            default: () => [],
        },
        dropzoneErrorList: {
            type: Array,
            default: () => [],
        },
        uploadButtonTitle: {
            type: String,
            default: 'Upload',
        },
        isDisabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            fileList: this.dropzoneFileList,
            errorList: this.dropzoneErrorList,
            options: {
                parallelUploads: 1,
                ...this.dropzoneOptions,
            },
        };
    },
    computed: {
        classList() {
            return [ELEMENT_CLASS, USER_INPUT_CLASS];
        },
        uploadButtonClassNames() {
            return {
                'upload-btn': true,
                disabled: this.isDisabled,
            };
        },
    },
    watch: {
        fileList(list) {
            this.$emit('update:dropzoneFileList', list);
        },
        errorList(list) {
            this.$emit('update:dropzoneErrorList', list);
        },
        isDisabled(newIsDisabled) {
            if (newIsDisabled) {
                this.$refs.vueDropzone.disable();
                return;
            }
            this.$refs.vueDropzone.enable();
        },
    },
    methods: {
        triggerUpload() {
            this.$refs.vueDropzone.$el.click();
        },
        getListSize() {
            return this.fileList.length;
        },
        uploadSuccess(file, response) {
            const listFile = {
                dropzoneFile: file,
                name: file.name,
                size: prettyBytes(file.size),
            };
            this.fileList.push(listFile);
            this.$emit('uploadSuccess', listFile, response);
        },
        uploadError(file, message) {
            this.errorList.push({ file, message });
            this.$refs.vueDropzone.removeFile(file);
        },
        fileRemoved(file) {
            const fileToRemove = this.fileList.find((listFile) => listFile.dropzoneFile === file);
            if (fileToRemove) {
                this.removeFromFileList(fileToRemove);
            }
        },
        removeFile(file) {
            this.removeFromFileList(file);
            this.$refs.vueDropzone.removeFile(file.dropzoneFile);
        },
        removeFromFileList(file) {
            const index = this.fileList.indexOf(file);
            if (index !== -1) {
                this.fileList.splice(index, 1);
            }
        },
    },
};
</script>
